<template>
  <div>
    <base-modal id="change-user-password" title="Change User Password">
      <template #modal-form>
        <form @submit.prevent="confirmUpdateUserPassword" class="m-3">

          <div class="form-group row no-gutters"  :class="{'has-error': passwordErrors.exist_password}">
            <label for="user-password" class="col-sm-4 col-form-label font-weight-bold text-right mr-1">
              Existing Password:
            </label>
            <div class="col-sm-7">
              <input type="password" id="user-password" class="form-control form-control-sm" required
                     placeholder="Type your Existing Password Here"
                     v-model="password.exist_password"
              >
            </div>
            <span class="help-block text-center w-100" v-if="!!passwordErrors.exist_password">
              <small><strong>{{ passwordErrors.exist_password }}</strong></small>
            </span>
          </div>

          <div class="form-group row no-gutters"  :class="{'has-error': passwordErrors.password}">
            <label for="user-new-password" class="col-sm-4 col-form-label font-weight-bold text-right mr-1">
              New Password:
            </label>
            <div class="col-sm-7">
              <input type="password" id="user-new-password" class="form-control form-control-sm" required
                     placeholder="Type your New Password Here"
                     v-model="password.password"
              >
            </div>
            <span class="help-block text-center w-100" v-if="!!passwordErrors.password">
              <small><strong>{{ passwordErrors.password }}</strong></small>
            </span>
          </div>

          <div class="form-group row no-gutters"  :class="{'has-error': passwordErrors.password}">
            <label for="user-confirm-password" class="col-sm-4 col-form-label font-weight-bold text-right mr-1">
              Confirm Password:
            </label>
            <div class="col-sm-7">
              <input type="password" id="user-confirm-password" class="form-control form-control-sm" required
                     placeholder="Confirm your New Password Here"
                     v-model="password.password_confirmation"
              >
            </div>
            <span class="help-block text-center w-100" v-if="!!passwordErrors.password">
              <small><strong>{{ passwordErrors.password }}</strong></small>
            </span>
          </div>

          <hr />
          <button type="submit" class="btn btn-sm btn-primary font-weight-bolder float-right">
            <span class="fas fa-save"></span>
            Update Password
          </button>
        </form>
      </template>
    </base-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

import BaseModal from "@/components/base/BaseModal";
import { AlertService } from "@/service/alert.service";

export default {
  name: "ChangeUserPassword",

  components: { BaseModal },

  data() {
    return {
      password: {},
      passwordErrors: {}
    }
  },

  methods: {
    ...mapActions([
        'changeUserPassword',
    ]),

    async confirmUpdateUserPassword() {
      if(await AlertService.questionAlertService('Are you sure you want to update your Password?', 'UPDATE PASSWORD', 'question')) {
        this.password['id'] = this.authUser.id;
        let updatedUserPassword = await this.changeUserPassword(this.password);
        if(updatedUserPassword) {
          if(updatedUserPassword.errors) {
            this.passwordErrors = updatedUserPassword.errors;
          } else {
            this.password = {};
            this.passwordErrors = {};
            AlertService.successAlertService('User Password Successfully Updated', 'UPDATE');
            $('#change-user-password').modal('hide');
          }
        } else {
          AlertService.warningAlertService('User Password Failed to Update', 'UPDATE');
        }
      }
    }
  },

  computed: {
    ...mapGetters([
        'authUser'
    ]),
  }

}
</script>

<style scoped>

</style>